import { Link } from "react-router-dom";
import Layout from "@/components/feature/Layout";
import FaqAccordion from "@/components/feature/FaqAccordion";
import { useSeo } from "@/hooks/useSeo";
import { faqs } from "@/mocks/faqs";

const BASE = "https://secretcomix.github.io";

export default function Faq() {
  useSeo({
    title: "常见问题 - 喵趣漫画网追更指南",
    description:
      "关于喵趣漫画网的收费、分类、更新频率、追更判断与投稿方式等常见问题的详细解答，帮助你更快找到喜欢的治愈番、搞笑萌漫、软萌画风作品。",
    keywords: "喵趣漫画网,常见问题,追更指南,萌系日常,治愈番,投稿",
    url: BASE + "/faq",
    type: "website",
    jsonLd: [
      {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        mainEntity: faqs.map((f) => ({
          "@type": "Question",
          name: f.q,
          acceptedAnswer: { "@type": "Answer", text: f.a },
        })),
      },
      {
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        itemListElement: [
          { "@type": "ListItem", position: 1, name: "首页", item: BASE + "/" },
          { "@type": "ListItem", position: 2, name: "常见问题", item: BASE + "/faq" },
        ],
      },
    ],
  });

  return (
    <Layout>
      <section className="container-page mt-8 md:mt-12">
        <nav className="mb-4 flex flex-wrap items-center gap-2 text-xs text-foreground-500" aria-label="面包屑">
          <Link to="/" className="hover:text-primary-700">首页</Link>
          <i className="ri-arrow-right-s-line" aria-hidden="true"></i>
          <span className="text-foreground-800">常见问题</span>
        </nav>

        <div className="mx-auto max-w-3xl text-center">
          <span className="chip bg-secondary-100 text-secondary-900">
            <i className="ri-question-line mr-1" aria-hidden="true"></i>
            追更指南
          </span>
          <h1 className="mt-4 text-2xl font-bold text-foreground-950 md:text-3xl">常见问题解答</h1>
          <p className="mt-3 text-sm leading-7 text-foreground-600">
            关于收费、分类、更新与投稿的常见疑问，这里都有答案。如果有更多问题，欢迎来信告诉我们。
          </p>
        </div>

        <div className="mx-auto mt-8 max-w-3xl">
          <FaqAccordion />
        </div>

        <div className="mx-auto mt-10 flex max-w-3xl flex-col items-center rounded-2xl border border-primary-200 bg-primary-100/50 px-6 py-8 text-center sm:flex-row sm:justify-between sm:text-left">
          <div>
            <h2 className="text-base font-bold text-foreground-950">还有其他问题？</h2>
            <p className="mt-1 text-sm text-foreground-700">联系我们，或去逛逛其他频道，找一部喜欢的作品吧。</p>
          </div>
          <div className="mt-4 flex flex-wrap gap-3 sm:mt-0">
            <Link to="/category/all" className="btn-primary">浏览全部作品</Link>
            <Link to="/about" className="btn-ghost">联系我们</Link>
          </div>
        </div>
      </section>
    </Layout>
  );
}